module.exports = __webpack_public_path__ + "img/brand_home_webshop_circle.fd4b113.svg";